 
import { createContext } from 'utils/react-helpers';

export const RadioGroupContext = createContext({
  name: 'RadioGroupContext',
  strict: false,
});
